export const ONE_CONFIGURATIONS_RESET_STATE = 'ONE_CONFIGURATIONS_RESET_STATE';
export const ONE_CONFIGURATIONS_CURRENT_ITEM = 'ONE_CONFIGURATIONS_CURRENT_ITEM';
 
export const ONE_CONFIGURATIONS_REQUEST_LOADING = 'ONE_CONFIGURATIONS_REQUEST_LOADING';
export const ONE_CONFIGURATIONS_REQUEST_SUCCESS = 'ONE_CONFIGURATIONS_REQUEST_SUCCESS';
export const ONE_CONFIGURATIONS_REQUEST_FAILED = 'ONE_CONFIGURATIONS_REQUEST_FAILED';
 
export const ONE_CONFIGURATIONS_CURRENT_ACTION = 'ONE_CONFIGURATIONS_CURRENT_ACTION';
export const ONE_CONFIGURATIONS_RESET_ACTION = 'ONE_CONFIGURATIONS_RESET_ACTION';